/* CPPerformance — checkout focus and trust */
(function () {
  function el(html) {
    const t = document.createElement('template');
    t.innerHTML = html.trim();
    return t.content.firstElementChild;
  }

  function updateProductTrust() {
    const main = document.querySelector("main[data-template^='product']");
    if (!main) return;
    const confidence = main.querySelector('.cp-buy-confidence');
    if (confidence && confidence.dataset.cpFocus !== 'true') {
      confidence.dataset.cpFocus = 'true';
      confidence.innerHTML = `
        <div class="cp-buy-confidence__item"><span class="cp-buy-confidence__icon">✓</span><span class="cp-buy-confidence__copy"><strong>Pasvormcheck</strong><span>Voertuiggegevens invullen bij twijfel</span></span></div>
        <div class="cp-buy-confidence__item"><span class="cp-buy-confidence__icon">✓</span><span class="cp-buy-confidence__copy"><strong>Montage mogelijk</strong><span>Op afspraak in Nederweert</span></span></div>
        <div class="cp-buy-confidence__item"><span class="cp-buy-confidence__icon">✓</span><span class="cp-buy-confidence__copy"><strong>Shopify checkout</strong><span>Beveiligd online afrekenen</span></span></div>
      `;
    }

    const help = main.querySelector('.cp-fitment-help');
    if (help && help.dataset.cpFocus !== 'true') {
      help.dataset.cpFocus = 'true';
      help.innerHTML = '<span class="cp-fitment-help__text"><strong>Twijfel over de pasvorm?</strong> Vul je voertuiggegevens in of laat ons eerst controleren.</span><a class="cp-fitment-help__link" href="/pages/contact">Pasvorm laten checken →</a>';
    }
  }

  function mountFastCheckoutCue() {
    const main = document.querySelector("main[data-template^='product']");
    if (!main) return;
    main.querySelectorAll('shopify-accelerated-checkout').forEach(function (checkout) {
      const prev = checkout.previousElementSibling;
      if (prev && prev.classList.contains('cp-fast-checkout-label')) return;
      checkout.insertAdjacentElement('beforebegin', el('<div class="cp-fast-checkout-label"><span>Sneller klaar?</span><strong>Reken direct af</strong></div>'));
    });
  }

  function checkoutButton(target) {
    return target.querySelector("button[name='checkout'], .cart__checkout-button, a[href*='/checkout']");
  }

  function mountCartFocus() {
    const targets = document.querySelectorAll('.cart__ctas, .cart-drawer__summary');
    targets.forEach(function (target) {
      const checkout = checkoutButton(target);
      if (!checkout) return;

      let ready = target.querySelector('.cp-cart-ready');
      if (!ready) {
        ready = el('<div class="cp-cart-ready"><strong>Klaar om af te rekenen?</strong><span>Rond je bestelling af via de beveiligde Shopify-checkout.</span></div>');
        checkout.insertAdjacentElement('beforebegin', ready);
      }

      let confidence = target.querySelector('.cp-cart-confidence');
      if (!confidence) {
        confidence = el('<div class="cp-cart-confidence cp-cart-confidence--upgrade cp-cart-confidence--focus"></div>');
        checkout.insertAdjacentElement('afterend', confidence);
      }
      confidence.classList.add('cp-cart-confidence--upgrade', 'cp-cart-confidence--focus');
      confidence.innerHTML = '<span>✓ Pasvormvraag? Vraag ons vóór het bestellen om controle.</span><span>✓ Montage mogelijk op afspraak in Nederweert.</span>';
    });
  }

  function improveCheckoutLabels() {
    document.querySelectorAll("button[name='checkout'], .cart__checkout-button").forEach(function (btn) {
      const text = (btn.textContent || '').trim().toLowerCase();
      if (text === 'checkout' || text === 'afrekenen' || text === 'naar afrekenen' || text === 'check out' || text === 'verder naar afrekenen') {
        const leaf = Array.from(btn.querySelectorAll('span')).find(function (span) {
          return !span.children.length && (span.textContent || '').trim().length > 0;
        });
        if (leaf) leaf.textContent = 'Verder naar afrekenen';
        else btn.textContent = 'Verder naar afrekenen';
      }
    });
  }

  function mountAll() {
    updateProductTrust();
    mountFastCheckoutCue();
    mountCartFocus();
    improveCheckoutLabels();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mountAll);
  else mountAll();

  document.addEventListener('shopify:section:load', function () { window.setTimeout(mountAll, 0); });
  document.addEventListener('cart:update', function () { window.setTimeout(mountAll, 0); });

  const observer = new MutationObserver(function () {
    window.clearTimeout(observer._cpCheckoutTimer);
    observer._cpCheckoutTimer = window.setTimeout(mountAll, 130);
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
